import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { CollegeList } from "./components/CollegeList";
import { CollegeRoute } from "./components/CollegeRoute";
import { Footer } from "./components/Footer";
import Navbar from "./components/Navbar";
import Resource from "./components/Resource";
import { Viewer } from "./components/Viewer";
import { PageNotFound } from "./view/404PageScreen";
import { AboutCSIT } from "./view/AboutCsitScreen";
import { Blog } from "./view/BlogScreen";
import { Entrance } from "./view/EntranceScreen";
import HomeScreen from "./view/HomeScreen";
import { SubjectScreen } from "./view/SubjectScreen";
function App() {
  return (
    <React.Fragment>
      <Navbar />
      <Switch>
        <Route exact path="/" component={HomeScreen} />
        <Route exact path="/about-csit" component={AboutCSIT} />
        <Route exact path="/blog" component={Blog} />
        <Route exact path="/entrance" component={Entrance} />
        <Route exact path="/first-sem/iit">
          <SubjectScreen
            sub_code="CSC 201"
            full_marks={100}
            pass_marks={40}
            internal_marks={40}
            title="Introduction to information technology"
            note_url="/first-sem/iit/notes"
            mq_url="/first-sem/iit/model-question"
            cq_url="/first-sem/iit/college-question"
            lw_url="/first-sem/iit/lab-work"
            soln_url="/first-sem/iit/solution"
            tb_url="/first-sem/iit/text-book"
            assignment_url="/first-sem/iit/assignment"
            ms_url="/first-sem/iit/micro-syllabus"
          />
        </Route>
        <Route exact path="/first-sem/iit/notes">
          <Resource
            title="Introduction to Information Technology"
            type="notes"
            items={[
              {
                title: "Notes & text book.pdf",
                link: "/https://www.facebook.com",
              },
              {
                title: "Notes & text book.pdf",
                link: "/https://www.facebook.com",
              },
            ]}
          />
        </Route>
        <Route exact path="/first-sem/iit/model-question">
          <Resource
            title="Introduction to Information Technology"
            type="Model question"
            items={[
              {
                title: "Model question 2074.pdf",
                link: "/https://www.facebook.com",
              },
              {
                title: "Notes & text book.pdf",
                link: "/https://www.facebook.com",
              },
              {
                title: "Notes & text book.pdf",
                link: "/https://www.facebook.com",
              },
              {
                title: "Model Question 2073.pdf",
                link: "/https://www.facebook.com",
              },
            ]}
          />
        </Route>
        <Route exact path="/first-sem/iit/micro-syllabus">
          <Resource
            title="Introduction to Information Technology"
            type="Micro Syllabus"
            items={[
              {
                title: "IIT New Micro-Syllabus",
                link:
                  "/first-sem/iit/micro-syllabus/preview/1NB16SFjDpeUd2C-tpfcQbLOL7i0AmCAY",
                contributor: "Aman Poddar",
                contributor_link: "https://facebook.com/james123",
              },
            ]}
          />
        </Route>
        <Route exact path="/first-sem/iit/college-question">
          <Resource
            title="Introduction to Information Technology"
            type="College Question"
            items={[
              {
                title: "Ascol 1st mid-term.pdf",
                link: "/https://www.facebook.com",
              },
              {
                title: "Patan Multiple Campus Collection.pdf",
                link: "/https://www.facebook.com",
              },
            ]}
          />
        </Route>
        <Route exact path="/first-sem/iit/lab-work">
          <Resource
            title="Introduction to Information Technology"
            type="Laboratory Works"
            items={[
              {
                title: "Lab 1.pdf",
                link: "/https://www.facebook.com",
              },
              {
                title: "Lab 2.pdf",
                link: "/https://www.facebook.com",
              },
            ]}
          />
        </Route>
        <Route exact path="/first-sem/iit/solution">
          <Resource
            title="Introduction to Information Technology"
            type="Solution"
            items={[
              {
                title: "Solution 2070-2074.pdf",
                link: "/https://www.facebook.com",
              },
            ]}
          />
        </Route>
        <Route exact path="/first-sem/iit/text-book">
          <Resource
            title="Introduction to Information Technology"
            type="Text Book"
            items={[
              {
                title: "Text book 8th Edition.pdf",
                link: "/https://www.facebook.com",
              },
              {
                title: "10th edition.pdf",
                link: "/https://www.facebook.com",
              },
            ]}
          />
        </Route>
        <Route exact path="/first-sem/iit/assignment">
          <Resource
            title="Introduction to Information Technology"
            type="Assignment"
            items={[
              {
                title: "Assignment 1.pdf",
                link: "/https://www.facebook.com",
              },
              {
                title: "Assignment 2.pdf",
                link: "/https://www.facebook.com",
              },
            ]}
          />
        </Route>
        <Route
          exact
          path="/first-sem/iit/micro-syllabus/preview/:id"
          component={Viewer}
        />
        <Route path="/college-list/all" component={CollegeList} />
        {/* College Dynamic Website Route */}
        <CollegeRoute />
        <Route path="/404_not_found" component={<PageNotFound />} />
        <Redirect to="/404_not_found" />
      </Switch>
      <Footer />
    </React.Fragment>
  );
}

export default App;
